import { lazy } from 'react';
import { authRoles } from 'app/auth';

const Types = lazy(() => import('./types/Types'));
const Card = lazy(() => import('./card/Card'));
const CardTransactions = lazy(() => import('./transaction/CardTransactions'));
const CardLists = lazy(() => import('./list/CardLists'));

const CardsAppConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: true,
                },
                toolbar: {
                    display: true,
                },
                footer: {
                    display: true,
                },
                leftSidePanel: {
                    display: true,
                },
                rightSidePanel: {
                    display: true,
                },
            },
        },
    },
    auth: authRoles.user,
    routes: [
        {
            path: 'apps/cards/types',
            element: <Types />,
            auth: ["card-type"],
        },
        {
            path: 'apps/cards/:cardId',
            element: <Card />,
            auth: ["card-new"],
        },
        {
            path: 'apps/cards/lists',
            element: <CardLists />,
            auth: ["card-mg"],
        },
        {
            path: 'apps/cards/transactions',
            element: <CardTransactions />,
            auth: ["card-tran"],
        },
    ],
};

export default CardsAppConfig;
